import React from 'react'
import Lottie from 'react-lottie'
import animationData from './animation.json'
import './Loader.css'

const Loader = props => (
  <div className="loader-holder">
    <div className="loader-container">
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        }}
        isClickToPauseDisabled={true}
      />
    </div>
  </div>
)

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader/index.js